import { RecipientRecord, IRecipientData, recipientFromJSON } from "common/records/Recipient";
import { Record, List, Map, fromJS } from "immutable";
import { Nullable } from "common/records";
import { IDocumentData } from "common/records/Document";
import { checkDate } from "common/helpers/Date";

export const signedDocumentFromJSON = (json: Partial<ISignedDocumentData>): SignedDocumentRecord => {
  const record: ISignedDocumentRecord = { ...(json as any) };

  if (json.recipients) {
    record.recipients = List(
      json.recipients.map((r) => {
        return recipientFromJSON(r);
      }),
    );
  }

  if (json.metadata) {
    record.metadata = fromJS(json.metadata);
  }

  if (json.completed_at) {
    record.completed_at = checkDate(json.completed_at);
  }

  return new SignedDocumentRecord(record);
};

export interface ISignedDocumentData {
  id: number;
  estimate_id: number;
  recipients: Array<Partial<IRecipientData>>;
  status: string;
  url: string;
  platform: string;
  metadata: any;
  document: Partial<IDocumentData>;
  document_id: Nullable<number>;
  signed_document_id: Nullable<number>;
  validation_status: Nullable<number>;
  message: string;
  loading?: boolean;
  completed_at: string;
}

export interface ISignedDocumentRecord {
  id: number;
  estimate_id: number;
  status: string;
  url: string;
  document_id: number;
  signed_document_id: number;
  recipients: List<RecipientRecord>;
  platform: string;
  metadata: Map<string, any>;
  loading: boolean;
  validation: Nullable<Map<string, any>>;
  validation_status: Nullable<number>;
  message: string;
  completed_at: Nullable<Date>;
}

export const defaultSignedDocumentProps = {
  id: 0,
  estimate_id: 0,
  status: "",
  url: "",
  recipients: List<RecipientRecord>(),
  loading: false,
  platform: "scribble",
  metadata: Map<string, any>(),
  document_id: 0,
  signed_document_id: 0,
  validation: null,
  validation_status: null,
  message: "",
  completed_at: null,
};

export class SignedDocumentRecord
  extends Record<ISignedDocumentRecord>(defaultSignedDocumentProps)
  implements ISignedDocumentRecord {}
